import React, { useEffect, useState } from "react";
import { translator } from "../../utils/i18n";
import { useDispatch, useSelector } from "react-redux";
import useForm from "react-hook-form";
import {
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField
} from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import { KeyboardDatePicker } from "@material-ui/pickers";
import { PHONE_ALLOWED_COUNTRIES } from "../../utils/constants";
import PhoneInput from "react-phone-number-input";
import metadataMobile from "libphonenumber-js/metadata.mobile.json";
import MobileStepper from "@material-ui/core/MobileStepper";
import Button from "@material-ui/core/Button";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import { useTheme } from "@material-ui/core/styles";
import SwipeableViews from "react-swipeable-views";
import { editPassword, saveInfosUser } from "../../utils/fetcher";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import { DateTime } from "luxon";
import { Trans } from "@lingui/macro";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import ErrorIcon from "@material-ui/icons/Error";
import VpnKeyIcon from "@material-ui/icons/VpnKey";
import SaveIcon from "@material-ui/icons/Save";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import InputMask from "react-input-mask";
import { resetMessageWithCode } from "../../actions";

function MyProfile() {
  const messagePassword = useSelector(state => state.messageWithCode);
  const [activeStep, setActiveStep] = useState(0);
  const [activeBtn, setActiveBtn] = useState(false);
  const [values, setValues] = useState({});
  const [valuesNextStep, setValuesNextStep] = useState({});
  const [showFormPassword, setShowFormPassword] = useState(false);
  const maxSteps = 2;
  const { handleSubmit, register, errors, setValue, watch, reset } = useForm();
  const theme = useTheme();
  const dispatch = useDispatch();
  const user = useSelector(state => state.patientArea.infosUser) || {};

  const saveInfos = values => dispatch(saveInfosUser(values));
  const editPasswordFunc = values => dispatch(editPassword(values));

  const [selectedDate, setSelectedDate] = useState();
  const [securityId, setSecurityId] = useState();
  const [showPassword, setShowPassword] = useState(true);
  const [showConfirmPassword, setShowConfirmPassword] = useState(true);
  const [showConfirmPasswordNew, setShowConfirmPasswordNew] = useState(true);
  const [phoneError, setPhoneError] = useState({});
  const [socialCodeError, setSocialCodeError] = useState({});

  const today = new Date();
  const minDate = new Date();
  minDate.setFullYear(today.getFullYear() - 150);

  useEffect(() => {
    if (Object.keys(user).length) {
      reset(user, { keepDefaultValues: false });

      setSelectedDate(
        user.datenaissance
          ? DateTime.fromFormat(user.datenaissance, "d/M/yyyy", {
              locale: "fr"
            })
          : null
      );
      setSecurityId(user.numsecu ? user.numsecu : "");
      register({
        name: "civilite",
        value: `${user.civilite === "1" ? "1" : "2"}`
      });
      register({
        name: "tel",
        value: `${user.tel_compte ? user.tel_compte : ""}`,
        required: translator()._("W_CE_CHAMP_EST_OBLIGATOIRE")
      });
      register({
        name: "indicatif_national_abreviation",
        value: `${
          user.indicatif_national_abreviation
            ? user.indicatif_national_abreviation
            : ""
        }`
      });
      register({
        name: "indicatif",
        value: `${user.indicatif ? user.indicatif : ""}`
      });
      register({
        name: "datenaissance",
        value: `${user.datenaissance ? user.datenaissance : ""}`
      });
      register({
        name: "numsecu",
        value: `${user.numsecu ? user.numsecu : ""}`
      });
      register({
        name: "titulaire_vital",
        value: `${user.carte_vitale === "Y" ? "Y" : "N"}`
      });
      register({
        name: "benef_cmu",
        value: `${user.cmu === "Y" ? "Y" : "N"}`
      });
    }
  }, [user, reset]);

  const validatePhone = values => {
    const errors = {};

    const phoneNumber = parsePhoneNumberFromString(
      values.tel || "",
      values.indicatif_national_abreviation || ""
    );
    const telIsValid = phoneNumber ? phoneNumber.isValid() : false;
    if (!values.tel || !telIsValid) {
      errors.tel = { message: translator()._("W_TEL_NON_VALIDE_WIDJET") };
    }
    setPhoneError(errors);
    return errors;
  };

  const handleBack = step => {
    if (step > 0) {
      setActiveBtn(false);
      setActiveStep(step - 1);
    }
  };

  const handleNext = (step, maxSteps) => {
    if (step + 1 < maxSteps) {
      setActiveBtn(false);
      setActiveStep(step + 1);
    }
  };

  const handleStepChange = step => {
    setActiveBtn(false);
    setActiveStep(step);
  };

  const onSubmit = values => {
    const result = validatePhone(values);
    if (Object.values(result).length === 0) {
      setValues(values);
      saveInfos(values);
    }
  };

  const onSubmitPassword = valuesPassword => {
    const newValue = {
      current_password: valuesPassword.current_password,
      new_password: valuesPassword.new_password,
      new_password_confirm: valuesPassword.new_password_confirm
    };
    editPasswordFunc(newValue);
  };

  const onChangeRadio = e => {
    setValue(e.target.name, e.target.value);
  };

  const handleChangePhone = tel => {
    setPhoneError({});
    const phoneNumber = parsePhoneNumberFromString(tel || "");
    if (phoneNumber) {
      setValue("tel", phoneNumber.format("NATIONAL").replace(/ /g, ""));
      setValue("indicatif_national_abreviation", phoneNumber.country);
      setValue("indicatif", phoneNumber.countryCallingCode);
    } else {
      setValue("tel", tel);
    }
  };

  const handleChangeDob = date => {
    const formatedDate = date
      ? date.day + "/" + date.month + "/" + date.year
      : "";
    setValue("datenaissance", formatedDate);
    setSelectedDate(date);
  };

  const onValidate = values => {
    const result = validatePhone(values);

    if (!socialCodeError.message && Object.values(result).length === 0) {
      setActiveBtn(true);
      setValuesNextStep(values);
      saveInfos(values);
    }
  };

  const handleClickPassword = e => {
    e.preventDefault();
    setShowPassword(!showPassword);
  };

  const handleClickConfirmPassword = e => {
    e.preventDefault();
    setShowConfirmPassword(!showConfirmPassword);
  };

  const handleClickConfirmPasswordNew = e => {
    e.preventDefault();
    setShowConfirmPasswordNew(!showConfirmPasswordNew);
  };

  const toggleFormPassword = (e, status = true) => {
    e.preventDefault();
    dispatch(resetMessageWithCode());
    setShowFormPassword(status);
  };

  const changeSecurityNum = e => {
    setSecurityId(e.target.value.replace(/\s/g, ""));
    setValue("numsecu", e.target.value.replace(/\s/g, ""));
    const numsecu = e.target.value.replace(/[^0-9]/g, "");
    if (numsecu.length < 15 && numsecu.length !== 0) {
      setSocialCodeError({ message: translator()._("W_SOCIAL_CODE_ERROR") });
    } else {
      setSocialCodeError({});
    }
  };

  const parsePhoneIndicatif = (indicatif, phone) => {
    if (!indicatif) {
      return phone ? phone : "";
    }
    return "+" + indicatif + phone?.slice(1);
  };

  return Object.keys(user).length ? (
    <>
      {showFormPassword && (
        <form
          onSubmit={handleSubmit(onSubmitPassword)}
          className="my-profile-form"
        >
          <h1 className="title-page">{translator()._("CP_MENU_PROFIL")}</h1>
          <div className="item-form item-form-password flex-direction-column">
            {messagePassword && (
              <div
                className={
                  messagePassword.code === 1
                    ? "custom-message custom-success mb-20"
                    : "custom-message custom-alert mb-20"
                }
              >
                {messagePassword.code === 1 ? (
                  <CheckCircleIcon />
                ) : (
                  <ErrorIcon />
                )}
                <div
                  dangerouslySetInnerHTML={{
                    __html: messagePassword.text
                  }}
                />
              </div>
            )}
            <div className="item position-relative">
              <TextField
                label={translator()._("W_MOT_DE_PASSE_ACTUEL")}
                variant="outlined"
                type={showPassword ? "password" : "text"}
                name="current_password"
                inputRef={register({
                  required: `${translator()._("W_CE_CHAMP_EST_OBLIGATOIRE")}`
                })}
              />
              <button
                className="toggle-show-password"
                onClick={handleClickPassword}
              >
                {!showPassword ? (
                  <VisibilityIcon className="light-blue" color="primary" />
                ) : (
                  <VisibilityOffIcon className="light-blue" color="primary" />
                )}
              </button>
              <span className="error">
                {errors.current_password && errors.current_password.message}
              </span>
            </div>

            <div className="item position-relative">
              <TextField
                label={translator()._("W_MOT_DE_PASSE_NOUVEAU")}
                variant="outlined"
                type={showConfirmPassword ? "password" : "text"}
                inputRef={register({
                  required: `${translator()._("W_CE_CHAMP_EST_OBLIGATOIRE")}`
                })}
                name="new_password"
              />
              <button
                className="toggle-show-password"
                onClick={handleClickConfirmPassword}
              >
                {!showConfirmPassword ? (
                  <VisibilityIcon className="light-blue" color="primary" />
                ) : (
                  <VisibilityOffIcon className="light-blue" color="primary" />
                )}
              </button>
              <span className="error">
                {errors.new_password && errors.new_password.message}
              </span>
            </div>

            <div className="item position-relative">
              <TextField
                label={translator()._("W_MOT_DE_PASSE_NOUVEAU_CONFIRM")}
                variant="outlined"
                type={showConfirmPasswordNew ? "password" : "text"}
                inputRef={register({
                  required: `${translator()._("W_CE_CHAMP_EST_OBLIGATOIRE")}`,
                  validate: value =>
                    value === watch("new_password") ||
                    translator()._("W_MOT_DE_PASSE_NON_IDENTIQUES")
                })}
                name="new_password_confirm"
              />
              <button
                className="toggle-show-password"
                onClick={handleClickConfirmPasswordNew}
              >
                {!showConfirmPasswordNew ? (
                  <VisibilityIcon className="light-blue" color="primary" />
                ) : (
                  <VisibilityOffIcon className="light-blue" color="primary" />
                )}
              </button>
              <span className="error">
                {errors.new_password_confirm &&
                  errors.new_password_confirm.message}
              </span>
            </div>

            <div className="d-flex justify-content-between">
              <Button
                variant="contained"
                color="primary"
                className="btn-light-blue"
                size="small"
                startIcon={<ArrowBackIcon />}
                onClick={e => toggleFormPassword(e, false)}
              >
                {translator()._("W_STEP_BOUTON_RETOUR")}
              </Button>
              <Button
                variant="contained"
                className="btn-validate"
                size="small"
                startIcon={<SaveIcon />}
                type="submit"
              >
                {translator()._("W_VALIDER")}
              </Button>
            </div>
          </div>
        </form>
      )}
      {!showFormPassword && (
        <form onSubmit={handleSubmit(onSubmit)} className="my-profile-form">
          <SwipeableViews
            axis={theme.direction === "rtl" ? "x-reverse" : "x"}
            index={activeStep}
            onChangeIndex={handleStepChange}
            className="swipeable-views"
            enableMouseEvents={false}
          >
            <div className="wrap-form-profile">
              <h1 className="title-page">{translator()._("CP_MENU_PROFIL")}</h1>
              <div className="item-form">
                <FormControl className="inline-radio">
                  <FormLabel className="mr-20">
                    {translator()._("W_STEP4_AJOUTER_UNE_PERSONE_CIVILITE")}
                  </FormLabel>
                  <RadioGroup
                    defaultValue={user.civilite === "1" ? "1" : "2"}
                    name="civilite"
                    onChange={onChangeRadio}
                    row
                  >
                    <FormControlLabel
                      value="1"
                      control={<Radio />}
                      label={translator()._("W_STEP4_CIVILITE_M")}
                    />
                    <FormControlLabel
                      value="2"
                      control={<Radio />}
                      label={translator()._("W_STEP4_CIVILITE_MME")}
                    />
                  </RadioGroup>
                </FormControl>
              </div>

              <div className="item-form">
                <div className="item">
                  <TextField
                    label={translator()._("W_STEP4_FORMULAIRE_NOM")}
                    variant="outlined"
                    inputRef={register({
                      required: `${translator()._(
                        "W_CE_CHAMP_EST_OBLIGATOIRE"
                      )}`
                    })}
                    name="nom"
                    defaultValue={values.nom || user.nom}
                  />
                  <span className="error">
                    {errors.nom && errors.nom.message}
                  </span>
                </div>
                <div className="item">
                  <TextField
                    label={translator()._("W_STEP4_FORMULAIRE_PRENOM")}
                    variant="outlined"
                    inputRef={register({
                      required: `${translator()._(
                        "W_CE_CHAMP_EST_OBLIGATOIRE"
                      )}`
                    })}
                    name="prenom"
                    defaultValue={user.prenom}
                  />
                  <span className="error">
                    {errors.prenom && errors.prenom.message}
                  </span>
                </div>
              </div>

              <div className="item-form">
                <div className="item">
                  <KeyboardDatePicker
                    className="bg-white"
                    value={selectedDate}
                    placeholder="jj/mm/aaaa"
                    onChange={handleChangeDob}
                    minDate={minDate}
                    maxDate={today}
                    format="dd/MM/yyyy"
                    label={translator()._("FORMULAIRE_DATE_DE_NAISSANCE")}
                    inputVariant="outlined"
                    name="datenaissance"
                    disableFuture
                    openTo="year"
                    views={["year", "month", "date"]}
                    okLabel={<Trans id="W_STEP_POPUP_BOUTON_OK" />}
                    cancelLabel={<Trans id="W_ANNULER" />}
                    invalidDateMessage={translator()._("W_DATE_INVALID")}
                    maxDateMessage={translator()._("W_MAX_DATE_MESSAGE")}
                    minDateMessage={translator()._("W_MIN_DATE_ALERT")}
                    inputRef={register({
                      required: `${translator()._(
                        "W_CE_CHAMP_EST_OBLIGATOIRE"
                      )}`
                    })}
                  />
                  <span className="error">
                    {errors.datenaissance && errors.datenaissance.message}
                  </span>
                </div>
                <div className="item">
                  <TextField
                    label={translator()._("W_STEP4_FORMULAIRE_EMAIL")}
                    variant="outlined"
                    inputRef={register({
                      required: `${translator()._(
                        "W_CE_CHAMP_EST_OBLIGATOIRE"
                      )}`,
                      pattern: {
                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                        message: `${translator()._(
                          "W_ADRESSE_E_MAIL_NON_VALIDE"
                        )}`
                      }
                    })}
                    name="email"
                    defaultValue={values.email || user.email_compte}
                  />
                  <span className="error">
                    {errors.email && errors.email.message}
                  </span>
                </div>
              </div>

              <div className="item-form">
                <PhoneInput
                  className="intl-tel-input"
                  countries={PHONE_ALLOWED_COUNTRIES}
                  country={
                    user.indicatif_national_abreviation
                      ? user.indicatif_national_abreviation
                      : "FR"
                  }
                  defaultCountry={
                    user.indicatif_national_abreviation
                      ? user.indicatif_national_abreviation
                      : "FR"
                  }
                  international={false}
                  onChange={phone => handleChangePhone(phone)}
                  limitMaxLength={true}
                  metadata={metadataMobile}
                  value={
                    user
                      ? parsePhoneIndicatif(
                          user.indicatif_national_fixe,
                          user.tel_compte
                        )
                      : ""
                  }
                  placeholder={`${translator()._(
                    "FORMULAIRE_TELEPHONE"
                  )} : 06 62 23 23 23`}
                />
                <span className="error">
                  {phoneError.tel && phoneError.tel.message}
                </span>
              </div>
              <div className="item-form profile-info">
                {translator()._("W_INFO_PROFILE")}
              </div>
            </div>
            <div className="next-step">
              <div className="item-form mb-10">
                <FormControl
                  fullWidth={true}
                  className="inline-radio column-radio-mobile"
                >
                  <FormLabel>
                    {translator()._("W_TITULAIRE_CARTE_VITALE")}
                  </FormLabel>
                  <RadioGroup
                    name="titulaire_vital"
                    defaultValue={user.carte_vitale === "Y" ? "Y" : "N"}
                    onChange={onChangeRadio}
                    row
                  >
                    <FormControlLabel
                      value="Y"
                      control={<Radio />}
                      label={translator()._("W_OUI")}
                    />
                    <FormControlLabel
                      value="N"
                      control={<Radio />}
                      label={translator()._("W_NON")}
                    />
                  </RadioGroup>
                </FormControl>
              </div>
              <div className="item-form">
                <FormControl
                  fullWidth={true}
                  className="inline-radio column-radio-mobile"
                >
                  <FormLabel>{translator()._("W_BENEFICIAIRE_CMU")}</FormLabel>
                  <RadioGroup
                    name="benef_cmu"
                    defaultValue={user.cmu === "Y" ? "Y" : "N"}
                    onChange={onChangeRadio}
                    row
                  >
                    <FormControlLabel
                      value="Y"
                      control={<Radio />}
                      label={translator()._("W_OUI")}
                    />
                    <FormControlLabel
                      value="N"
                      control={<Radio />}
                      label={translator()._("W_NON")}
                    />
                  </RadioGroup>
                </FormControl>
              </div>
              <div className="item-form item-address">
                <TextField
                  name="adresse"
                  id="outlined-multiline-static"
                  label={translator()._("W_ADRESSE")}
                  multiline
                  rows="2"
                  variant="outlined"
                  autoComplete="off"
                  inputRef={register}
                  fullWidth={true}
                  defaultValue={valuesNextStep.adresse || user.adresse}
                />
              </div>
              <div className="item-form">
                <div className="item">
                  <TextField
                    name="codepostal"
                    label={translator()._("W_CODE_POSTAL")}
                    variant="outlined"
                    inputRef={register({
                      pattern: {
                        value: /^[0-9]{5}$/i,
                        message: `${translator()._("W_POSTAL_CODE_INVALID")}`
                      }
                    })}
                    autoComplete="off"
                    defaultValue={valuesNextStep.codepostal || user.codepostal}
                  />
                  <span className="error">
                    {errors.codepostal && errors.codepostal.message}
                  </span>
                </div>
                <div className="item">
                  <TextField
                    name="ville"
                    label={translator()._("W_VILLE")}
                    variant="outlined"
                    inputRef={register}
                    autoComplete="off"
                    defaultValue={valuesNextStep.ville || user.ville}
                  />
                </div>
              </div>
              <div className="item-form">
                <div className="item">
                  <InputMask
                    value={securityId}
                    mask="* ** ** ** *** *** **"
                    disabled={false}
                    onChange={changeSecurityNum}
                  >
                    {() => (
                      <TextField
                        label={translator()._("W_SECURITE_SOCIAL")}
                        variant="outlined"
                      />
                    )}
                  </InputMask>
                  {socialCodeError.message}
                </div>
                <div className="item">
                  <TextField
                    name="medecintraitant"
                    label={translator()._("W_MEDECIN_TRAITANT")}
                    variant="outlined"
                    inputRef={register}
                    defaultValue={
                      valuesNextStep.medecintraitant || user.medecintraitant
                    }
                  />
                </div>
              </div>
              <div className="item-form">
                <div className="item">
                  <TextField
                    name="villemedecin"
                    label={translator()._("W_VILLE_MEDECIN_TRAITANT")}
                    variant="outlined"
                    inputRef={register}
                    defaultValue={
                      valuesNextStep.villemedecin || user.villemedecin
                    }
                  />
                </div>
                <div className="item">
                  <TextField
                    name="profession"
                    label={translator()._("W_PROFESSION")}
                    variant="outlined"
                    inputRef={register}
                    defaultValue={valuesNextStep.profession || user.profession}
                  />
                </div>
              </div>
            </div>
          </SwipeableViews>
          <div style={{ display: "flex", justifyContent: "end" }}>
            <MobileStepper
              steps={maxSteps}
              position="static"
              activeStep={activeStep}
              className="mobile-stepper-custom no-padding"
              variant="text"
              nextButton={
                <Button
                  className="no-padding"
                  style={{ minWidth: "35px" }}
                  disabled={activeStep === maxSteps - 1}
                  onClick={() => handleNext(activeStep, maxSteps)}
                >
                  <KeyboardArrowRight />
                </Button>
              }
              backButton={
                <Button
                  className="no-padding"
                  style={{ minWidth: "35px" }}
                  disabled={activeStep === 0}
                  onClick={() => handleBack(activeStep)}
                >
                  <KeyboardArrowLeft />
                </Button>
              }
            />
          </div>
          <div className="bottom-profile">
            <Button
              onClick={toggleFormPassword}
              variant="contained"
              color="default"
              startIcon={<VpnKeyIcon />}
              className="edit-password"
            >
              {translator()._("W_MODIFIER_MOT_DE_PASSE")}
            </Button>
            <Button
              size="small"
              type="submit"
              variant="contained"
              color="secondary"
              className={activeBtn ? "" : "btn-validate"}
              onClick={handleSubmit(onValidate)}
            >
              {translator()._("W_VALIDER")}
              <i className="material-icons">done</i>
            </Button>
          </div>
        </form>
      )}
    </>
  ) : null;
}

export default MyProfile;
